/* ABC: «недавно смотрели». Список handle'ов лежит в localStorage покупателя,
   карточки собираются из /products/<handle>.js — штатного эндпоинта Shopify.
   Раскладка повторяет сайт владельца: горизонтальная карусель по 4 карточки
   на десктопе (3 на планшете, 2 на телефоне), шаг прокрутки — одна карточка,
   точки-страницы под лентой, внутри карточки — свой слайдер фото с точками. */
(function () {
  var KEY = 'abc:recently-viewed';
  var MAX_STORED = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }
  function remember(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }
  function money(cents, format) {
    /* ABC 29.09: формат магазина + знак CA$/A$/HK$/S$/AED — assets/abc-money.js */
    if (window.abcMoney) return window.abcMoney.format(cents, format);
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    return v;
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* точки поверх фото — та же разметка и CSS, что у карточек каталога */
  function dots(n) {
    var box = document.createElement('div');
    box.className = 'abc-dots';
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'abc-dots__dot' + (i === 0 ? ' is-current' : '');
      box.appendChild(d);
    }
    return box;
  }

  function card(p, format) {
    var images = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean).slice(0, 6);
    var li = document.createElement('li');
    li.className = 'product-card abc-recent__card';

    var gallery = document.createElement('div');
    gallery.className = 'card-gallery abc-recent__gallery';
    var strip = document.createElement('div');
    strip.className = 'abc-recent__frames';
    images.forEach(function (src) {
      var a = document.createElement('a');
      a.className = 'abc-recent__frame';
      a.href = '/products/' + p.handle;
      a.setAttribute('aria-label', p.title);
      var img = document.createElement('img');
      img.src = sized(src, 600);
      img.alt = '';
      img.loading = 'lazy';
      a.appendChild(img);
      strip.appendChild(a);
    });
    gallery.appendChild(strip);
    if (images.length > 1) {
      var d = dots(images.length);
      gallery.appendChild(d);
      strip.addEventListener('scroll', function () {
        var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
        [].forEach.call(d.children, function (dot, k) {
          dot.classList.toggle('is-current', k === i);
        });
      }, { passive: true });
    }

    var meta = document.createElement('a');
    meta.className = 'abc-recent__meta';
    meta.href = '/products/' + p.handle;
    meta.innerHTML =
      '<p role="heading" aria-level="3">' + p.title + '</p>' +
      '<div class="price">' + money(p.price, format) + '</div>';

    li.appendChild(gallery);
    li.appendChild(meta);
    return li;
  }

  /* точки-страницы под лентой: одна на «экран» из perView карточек */
  function pager(root, track) {
    var box = root.querySelector('.abc-recent__pager');
    if (!box) return;
    function perView() {
      var first = track.firstElementChild;
      if (!first) return 1;
      var w = first.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return Math.max(1, Math.round((track.clientWidth + gap) / (w + gap)));
    }
    function build() {
      var n = track.children.length;
      var pages = Math.max(1, Math.ceil(n / perView()));
      if (pages < 2) { box.hidden = true; box.innerHTML = ''; return; }
      box.hidden = false;
      box.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('span');
        b.className = 'abc-recent__bullet' + (i === 0 ? ' is-current' : '');
        box.appendChild(b);
      }
      mark();
    }
    function mark() {
      var kids = box.children;
      if (!kids.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      var i = Math.round(ratio * (kids.length - 1));
      [].forEach.call(kids, function (b, k) { b.classList.toggle('is-current', k === i); });
    }
    track.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', build);
    build();
  }

  function init(root) {
    var current = root.getAttribute('data-current') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    var format = root.getAttribute('data-money-format') || '';
    if (current) remember(current);

    var handles = read().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;

    var track = root.querySelector('.abc-recent__track');
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var shown = 0;
      items.forEach(function (p) { if (p) { track.appendChild(card(p, format)); shown++; } });
      if (!shown) return;
      root.hidden = false;
      pager(root, track);
    });
  }

  function boot() {
    document.querySelectorAll('[data-abc-recent]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
